export default function isSupporter(entity, supporterMap, userId) {
  return Boolean(supporterMap?.get(entity?.uuid)?.has(userId));
}
